{
  "contractName": "dreamBidFee",
  "abi": [
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint16",
          "name": "newFee",
          "type": "uint16"
        },
        {
          "indexed": false,
          "internalType": "uint16",
          "name": "oldFee",
          "type": "uint16"
        }
      ],
      "name": "FeeSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "previousOwner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "OwnershipTransferred",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "_dreamBiddingFee",
      "outputs": [
        {
          "internalType": "uint16",
          "name": "",
          "type": "uint16"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [],
      "name": "renounceOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "transferOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "protocolFee",
      "outputs": [
        {
          "internalType": "uint16",
          "name": "",
          "type": "uint16"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [],
      "name": "getProtocolOwnerAddress",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [
        {
          "internalType": "uint16",
          "name": "newFee",
          "type": "uint16"
        }
      ],
      "name": "setProtocolFee",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  "metadata": "{\"compiler\":{\"version\":\"0.8.17+commit.8df45f5f\"},\"language\":\"Solidity\",\"output\":{\"abi\":[{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint16\",\"name\":\"newFee\",\"type\":\"uint16\"},{\"indexed\":false,\"internalType\":\"uint16\",\"name\":\"oldFee\",\"type\":\"uint16\"}],\"name\":\"FeeSet\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"previousOwner\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"newOwner\",\"type\":\"address\"}],\"name\":\"OwnershipTransferred\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"_dreamBiddingFee\",\"outputs\":[{\"internalType\":\"uint16\",\"name\":\"\",\"type\":\"uint16\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"getProtocolOwnerAddress\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"owner\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"protocolFee\",\"outputs\":[{\"internalType\":\"uint16\",\"name\":\"\",\"type\":\"uint16\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"renounceOwnership\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint16\",\"name\":\"newFee\",\"type\":\"uint16\"}],\"name\":\"setProtocolFee\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"newOwner\",\"type\":\"address\"}],\"name\":\"transferOwnership\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"}],\"devdoc\":{\"kind\":\"dev\",\"methods\":{\"owner()\":{\"details\":\"Returns the address of the current owner.\"},\"renounceOwnership()\":{\"details\":\"Leaves the contract without owner. It will not be possible to call `onlyOwner` functions anymore. Can only be called by the current owner. NOTE: Renouncing ownership will leave the contract without an owner, thereby removing any functionality that is only available to the owner.\"},\"transferOwnership(address)\":{\"details\":\"Transfers ownership of the contract to a new account (`newOwner`). Can only be called by the current owner.\"}},\"version\":1},\"userdoc\":{\"kind\":\"user\",\"methods\":{},\"version\":1}},\"settings\":{\"compilationTarget\":{\"project:/contracts/dreamBidFee.sol\":\"dreamBidFee\"},\"evmVersion\":\"london\",\"libraries\":{},\"metadata\":{\"bytecodeHash\":\"ipfs\"},\"optimizer\":{\"enabled\":false,\"runs\":200},\"remappings\":[]},\"sources\":{\"@openzeppelin/contracts/access/Ownable.sol\":{\"keccak256\":\"0xa94b34880e3c1b0b931662cb1c09e5dfa6662f31cba80e07c5ee71cd135c9673\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://40fb1b5102468f783961d0af743f91b9980cf66b50d1d12009f6bb1869cea4d2\",\"dweb:/ipfs/QmYqEbJML4jB1GHbzD4cUZDtJg5wVwNm3vDJq1GbyDus8y\"]},\"@openzeppelin/contracts/utils/Context.sol\":{\"keccak256\":\"0xe2e337e6dde9ef6b680e07338c493ebea1b5fd09b43424112868e9cc1706bca7\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://6df0ddf21ce9f58271bdfaa85cde98b200ef242a05a3f85c2bc10a8294800a92\",\"dweb:/ipfs/QmRK2Y5Yc6BK7tGKkgsgn3aJEQGi5aakeSPZvS65PV8Xp3\"]},\"project:/contracts/dreamBidFee.sol\":{\"keccak256\":\"0xcaf6dde8dca20f5311874722d0f932fd43db5798c48c8ecb87ed0ed64d536aba\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://a340a333cf0a065c36208566f667253b2ef794b85dbe7d7a4793a23f3782af3e\",\"dweb:/ipfs/QmVAnLDNi6sYiPkJXAHsDRNkHZFkFDy8rPfSMchTuuneM6\"]}},\"version\":1}",
  "bytecode": "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",
  "deployedBytecode": "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",
  "immutableReferences": {},
  "generatedSources": [],
  "deployedGeneratedSources": [
    {
      "ast": {
        "nodeType": "YulBlock",
        "src": "0:5085:10",
        "statements": [
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "52:81:10",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "62:65:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "77:5:10"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "84:42:10",
                        "type": "",
                        "value": "0xffffffffffffffffffffffffffffffffffffffff"
                      }
                    ],
                    "functionName": {
                      "name": "and",
                      "nodeType": "YulIdentifier",
                      "src": "73:3:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "73:54:10"
                  },
                  "variableNames": [
                    {
                      "name": "cleaned",
                      "nodeType": "YulIdentifier",
                      "src": "62:7:10"
                    }
                  ]
                }
              ]
            },
            "name": "cleanup_t_uint160",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "34:5:10",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "cleaned",
                "nodeType": "YulTypedName",
                "src": "44:7:10",
                "type": ""
              }
            ],
            "src": "7:126:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "184:51:10",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "194:35:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "223:5:10"
                      }
                    ],
                    "functionName": {
                      "name": "cleanup_t_uint160",
                      "nodeType": "YulIdentifier",
                      "src": "205:17:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "205:24:10"
                  },
                  "variableNames": [
                    {
                      "name": "cleaned",
                      "nodeType": "YulIdentifier",
                      "src": "194:7:10"
                    }
                  ]
                }
              ]
            },
            "name": "cleanup_t_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "166:5:10",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "cleaned",
                "nodeType": "YulTypedName",
                "src": "176:7:10",
                "type": ""
              }
            ],
            "src": "139:96:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "306:53:10",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "323:3:10"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "346:5:10"
                          }
                        ],
                        "functionName": {
                          "name": "cleanup_t_address",
                          "nodeType": "YulIdentifier",
                          "src": "328:17:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "328:24:10"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "316:6:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "316:37:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "316:37:10"
                }
              ]
            },
            "name": "abi_encode_t_address_to_t_address_fromStack",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "294:5:10",
                "type": ""
              },
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "301:3:10",
                "type": ""
              }
            ],
            "src": "241:118:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "463:124:10",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "473:26:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "485:9:10"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "496:2:10",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "481:3:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "481:18:10"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "473:4:10"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "553:6:10"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "566:9:10"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "577:1:10",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "562:3:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "562:17:10"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_address_to_t_address_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "509:43:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "509:71:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "509:71:10"
                }
              ]
            },
            "name": "abi_encode_tuple_t_address__to_t_address__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "435:9:10",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "447:6:10",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "458:4:10",
                "type": ""
              }
            ],
            "src": "365:222:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "637:45:10",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "647:29:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "662:5:10"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "669:6:10",
                        "type": "",
                        "value": "0xffff"
                      }
                    ],
                    "functionName": {
                      "name": "and",
                      "nodeType": "YulIdentifier",
                      "src": "658:3:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "658:18:10"
                  },
                  "variableNames": [
                    {
                      "name": "cleaned",
                      "nodeType": "YulIdentifier",
                      "src": "647:7:10"
                    }
                  ]
                }
              ]
            },
            "name": "cleanup_t_uint16",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "619:5:10",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "cleaned",
                "nodeType": "YulTypedName",
                "src": "629:7:10",
                "type": ""
              }
            ],
            "src": "593:89:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "751:52:10",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "768:3:10"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "790:5:10"
                          }
                        ],
                        "functionName": {
                          "name": "cleanup_t_uint16",
                          "nodeType": "YulIdentifier",
                          "src": "773:16:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "773:23:10"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "761:6:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "761:36:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "761:36:10"
                }
              ]
            },
            "name": "abi_encode_t_uint16_to_t_uint16_fromStack",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "739:5:10",
                "type": ""
              },
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "746:3:10",
                "type": ""
              }
            ],
            "src": "688:115:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "905:122:10",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "915:26:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "927:9:10"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "938:2:10",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "923:3:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "923:18:10"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "915:4:10"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "993:6:10"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1006:9:10"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "1017:1:10",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "1002:3:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1002:17:10"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_uint16_to_t_uint16_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "951:41:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "951:69:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "951:69:10"
                }
              ]
            },
            "name": "abi_encode_tuple_t_uint16__to_t_uint16__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "877:9:10",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "889:6:10",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "900:4:10",
                "type": ""
              }
            ],
            "src": "809:218:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1073:35:10",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "1083:19:10",
                  "value": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1099:2:10",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "1093:5:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1093:9:10"
                  },
                  "variableNames": [
                    {
                      "name": "memPtr",
                      "nodeType": "YulIdentifier",
                      "src": "1083:6:10"
                    }
                  ]
                }
              ]
            },
            "name": "allocate_unbounded",
            "nodeType": "YulFunctionDefinition",
            "returnVariables": [
              {
                "name": "memPtr",
                "nodeType": "YulTypedName",
                "src": "1066:6:10",
                "type": ""
              }
            ],
            "src": "1033:75:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1203:28:10",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1220:1:10",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1223:1:10",
                        "type": "",
                        "value": "0"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "1213:6:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1213:12:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "1213:12:10"
                }
              ]
            },
            "name": "revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b",
            "nodeType": "YulFunctionDefinition",
            "src": "1114:117:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1326:28:10",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1343:1:10",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1346:1:10",
                        "type": "",
                        "value": "0"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "1336:6:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1336:12:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "1336:12:10"
                }
              ]
            },
            "name": "revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db",
            "nodeType": "YulFunctionDefinition",
            "src": "1237:117:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1402:78:10",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1458:16:10",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1467:1:10",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "1470:1:10",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "1460:6:10"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1460:12:10"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1460:12:10"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "1425:5:10"
                          },
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "1449:5:10"
                              }
                            ],
                            "functionName": {
                              "name": "cleanup_t_uint16",
                              "nodeType": "YulIdentifier",
                              "src": "1432:16:10"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "1432:23:10"
                          }
                        ],
                        "functionName": {
                          "name": "eq",
                          "nodeType": "YulIdentifier",
                          "src": "1422:2:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1422:34:10"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "1415:6:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1415:42:10"
                  },
                  "nodeType": "YulIf",
                  "src": "1412:62:10"
                }
              ]
            },
            "name": "validator_revert_t_uint16",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "1395:5:10",
                "type": ""
              }
            ],
            "src": "1360:120:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1537:86:10",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "1547:29:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "1569:6:10"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "1556:12:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1556:20:10"
                  },
                  "variableNames": [
                    {
                      "name": "value",
                      "nodeType": "YulIdentifier",
                      "src": "1547:5:10"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "1611:5:10"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_t_uint16",
                      "nodeType": "YulIdentifier",
                      "src": "1585:25:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1585:32:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "1585:32:10"
                }
              ]
            },
            "name": "abi_decode_t_uint16",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "offset",
                "nodeType": "YulTypedName",
                "src": "1515:6:10",
                "type": ""
              },
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "1523:3:10",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "1531:5:10",
                "type": ""
              }
            ],
            "src": "1486:137:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1694:262:10",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1740:83:10",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b",
                            "nodeType": "YulIdentifier",
                            "src": "1742:77:10"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1742:79:10"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1742:79:10"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "1715:7:10"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1724:9:10"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "1711:3:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1711:23:10"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1736:2:10",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "1707:3:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1707:32:10"
                  },
                  "nodeType": "YulIf",
                  "src": "1704:119:10"
                },
                {
                  "nodeType": "YulBlock",
                  "src": "1833:116:10",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "1848:15:10",
                      "value": {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1862:1:10",
                        "type": "",
                        "value": "0"
                      },
                      "variables": [
                        {
                          "name": "offset",
                          "nodeType": "YulTypedName",
                          "src": "1852:6:10",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "nodeType": "YulAssignment",
                      "src": "1877:62:10",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "headStart",
                                "nodeType": "YulIdentifier",
                                "src": "1911:9:10"
                              },
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "1922:6:10"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "1907:3:10"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "1907:22:10"
                          },
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "1931:7:10"
                          }
                        ],
                        "functionName": {
                          "name": "abi_decode_t_uint16",
                          "nodeType": "YulIdentifier",
                          "src": "1887:19:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1887:52:10"
                      },
                      "variableNames": [
                        {
                          "name": "value0",
                          "nodeType": "YulIdentifier",
                          "src": "1877:6:10"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_uint16",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "1664:9:10",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "1675:7:10",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "1687:6:10",
                "type": ""
              }
            ],
            "src": "1629:327:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "2005:79:10",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "2062:16:10",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2071:1:10",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "2074:1:10",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "2064:6:10"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2064:12:10"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2064:12:10"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "2028:5:10"
                          },
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "2053:5:10"
                              }
                            ],
                            "functionName": {
                              "name": "cleanup_t_address",
                              "nodeType": "YulIdentifier",
                              "src": "2035:17:10"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "2035:24:10"
                          }
                        ],
                        "functionName": {
                          "name": "eq",
                          "nodeType": "YulIdentifier",
                          "src": "2025:2:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2025:35:10"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "2018:6:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2018:43:10"
                  },
                  "nodeType": "YulIf",
                  "src": "2015:63:10"
                }
              ]
            },
            "name": "validator_revert_t_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "1998:5:10",
                "type": ""
              }
            ],
            "src": "1962:122:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "2142:87:10",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "2152:29:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "2174:6:10"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "2161:12:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2161:20:10"
                  },
                  "variableNames": [
                    {
                      "name": "value",
                      "nodeType": "YulIdentifier",
                      "src": "2152:5:10"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "2217:5:10"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_t_address",
                      "nodeType": "YulIdentifier",
                      "src": "2190:26:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2190:33:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "2190:33:10"
                }
              ]
            },
            "name": "abi_decode_t_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "offset",
                "nodeType": "YulTypedName",
                "src": "2120:6:10",
                "type": ""
              },
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "2128:3:10",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "2136:5:10",
                "type": ""
              }
            ],
            "src": "2090:139:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "2301:263:10",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "2347:83:10",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b",
                            "nodeType": "YulIdentifier",
                            "src": "2349:77:10"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2349:79:10"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2349:79:10"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "2322:7:10"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2331:9:10"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "2318:3:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2318:23:10"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2343:2:10",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "2314:3:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2314:32:10"
                  },
                  "nodeType": "YulIf",
                  "src": "2311:119:10"
                },
                {
                  "nodeType": "YulBlock",
                  "src": "2440:117:10",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "2455:15:10",
                      "value": {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2469:1:10",
                        "type": "",
                        "value": "0"
                      },
                      "variables": [
                        {
                          "name": "offset",
                          "nodeType": "YulTypedName",
                          "src": "2459:6:10",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "nodeType": "YulAssignment",
                      "src": "2484:63:10",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "headStart",
                                "nodeType": "YulIdentifier",
                                "src": "2519:9:10"
                              },
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "2530:6:10"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "2515:3:10"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "2515:22:10"
                          },
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "2539:7:10"
                          }
                        ],
                        "functionName": {
                          "name": "abi_decode_t_address",
                          "nodeType": "YulIdentifier",
                          "src": "2494:20:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2494:53:10"
                      },
                      "variableNames": [
                        {
                          "name": "value0",
                          "nodeType": "YulIdentifier",
                          "src": "2484:6:10"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "2271:9:10",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "2282:7:10",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "2294:6:10",
                "type": ""
              }
            ],
            "src": "2235:329:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "2692:202:10",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "2702:26:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "2714:9:10"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2725:2:10",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "2710:3:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2710:18:10"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "2702:4:10"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "2780:6:10"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2793:9:10"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "2804:1:10",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "2789:3:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2789:17:10"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_uint16_to_t_uint16_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "2738:41:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2738:69:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "2738:69:10"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value1",
                        "nodeType": "YulIdentifier",
                        "src": "2859:6:10"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2872:9:10"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "2883:2:10",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "2868:3:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2868:18:10"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_uint16_to_t_uint16_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "2817:41:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2817:70:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "2817:70:10"
                }
              ]
            },
            "name": "abi_encode_tuple_t_uint16_t_uint16__to_t_uint16_t_uint16__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "2656:9:10",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "2668:6:10",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "2676:6:10",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "2687:4:10",
                "type": ""
              }
            ],
            "src": "2570:324:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "2996:73:10",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "3013:3:10"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "3018:6:10"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "3006:6:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3006:19:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "3006:19:10"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "3034:29:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "3053:3:10"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3058:4:10",
                        "type": "",
                        "value": "0x20"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "3049:3:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3049:14:10"
                  },
                  "variableNames": [
                    {
                      "name": "updated_pos",
                      "nodeType": "YulIdentifier",
                      "src": "3034:11:10"
                    }
                  ]
                }
              ]
            },
            "name": "array_storeLengthForEncoding_t_string_memory_ptr_fromStack",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "2968:3:10",
                "type": ""
              },
              {
                "name": "length",
                "nodeType": "YulTypedName",
                "src": "2973:6:10",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "updated_pos",
                "nodeType": "YulTypedName",
                "src": "2984:11:10",
                "type": ""
              }
            ],
            "src": "2900:169:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "3181:119:10",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "memPtr",
                            "nodeType": "YulIdentifier",
                            "src": "3203:6:10"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "3211:1:10",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "3199:3:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3199:14:10"
                      },
                      {
                        "hexValue": "4f776e61626c653a206e6577206f776e657220697320746865207a65726f2061",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "3215:34:10",
                        "type": "",
                        "value": "Ownable: new owner is the zero a"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "3192:6:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3192:58:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "3192:58:10"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "memPtr",
                            "nodeType": "YulIdentifier",
                            "src": "3271:6:10"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "3279:2:10",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "3267:3:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3267:15:10"
                      },
                      {
                        "hexValue": "646472657373",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "3284:8:10",
                        "type": "",
                        "value": "ddress"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "3260:6:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3260:33:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "3260:33:10"
                }
              ]
            },
            "name": "store_literal_in_memory_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "memPtr",
                "nodeType": "YulTypedName",
                "src": "3173:6:10",
                "type": ""
              }
            ],
            "src": "3075:225:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "3452:220:10",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "3462:74:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "3528:3:10"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3533:2:10",
                        "type": "",
                        "value": "38"
                      }
                    ],
                    "functionName": {
                      "name": "array_storeLengthForEncoding_t_string_memory_ptr_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "3469:58:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3469:67:10"
                  },
                  "variableNames": [
                    {
                      "name": "pos",
                      "nodeType": "YulIdentifier",
                      "src": "3462:3:10"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "3634:3:10"
                      }
                    ],
                    "functionName": {
                      "name": "store_literal_in_memory_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe",
                      "nodeType": "YulIdentifier",
                      "src": "3545:88:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3545:93:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "3545:93:10"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "3647:19:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "3658:3:10"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3663:2:10",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "3654:3:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3654:12:10"
                  },
                  "variableNames": [
                    {
                      "name": "end",
                      "nodeType": "YulIdentifier",
                      "src": "3647:3:10"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_t_stringliteral_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe_to_t_string_memory_ptr_fromStack",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "3440:3:10",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "3448:3:10",
                "type": ""
              }
            ],
            "src": "3306:366:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "3849:248:10",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "3859:26:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "3871:9:10"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3882:2:10",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "3867:3:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3867:18:10"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "3859:4:10"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "3906:9:10"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "3917:1:10",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "3902:3:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3902:17:10"
                      },
                      {
                        "arguments": [
                          {
                            "name": "tail",
                            "nodeType": "YulIdentifier",
                            "src": "3925:4:10"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "3931:9:10"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "3921:3:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3921:20:10"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "3895:6:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3895:47:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "3895:47:10"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "3951:139:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "tail",
                        "nodeType": "YulIdentifier",
                        "src": "4085:4:10"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_stringliteral_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe_to_t_string_memory_ptr_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "3959:124:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3959:131:10"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "3951:4:10"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "3829:9:10",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "3844:4:10",
                "type": ""
              }
            ],
            "src": "3678:419:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "4209:76:10",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "memPtr",
                            "nodeType": "YulIdentifier",
                            "src": "4231:6:10"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "4239:1:10",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "4227:3:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4227:14:10"
                      },
                      {
                        "hexValue": "4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "4243:34:10",
                        "type": "",
                        "value": "Ownable: caller is not the owner"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "4220:6:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4220:58:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "4220:58:10"
                }
              ]
            },
            "name": "store_literal_in_memory_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "memPtr",
                "nodeType": "YulTypedName",
                "src": "4201:6:10",
                "type": ""
              }
            ],
            "src": "4103:182:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "4437:220:10",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "4447:74:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "4513:3:10"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "4518:2:10",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "array_storeLengthForEncoding_t_string_memory_ptr_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "4454:58:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4454:67:10"
                  },
                  "variableNames": [
                    {
                      "name": "pos",
                      "nodeType": "YulIdentifier",
                      "src": "4447:3:10"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "4619:3:10"
                      }
                    ],
                    "functionName": {
                      "name": "store_literal_in_memory_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe",
                      "nodeType": "YulIdentifier",
                      "src": "4530:88:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4530:93:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "4530:93:10"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "4632:19:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "4643:3:10"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "4648:2:10",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "4639:3:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4639:12:10"
                  },
                  "variableNames": [
                    {
                      "name": "end",
                      "nodeType": "YulIdentifier",
                      "src": "4632:3:10"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_t_stringliteral_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe_to_t_string_memory_ptr_fromStack",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "4425:3:10",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "4433:3:10",
                "type": ""
              }
            ],
            "src": "4291:366:10"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "4834:248:10",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "4844:26:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "4856:9:10"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "4867:2:10",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "4852:3:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4852:18:10"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "4844:4:10"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "4891:9:10"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "4902:1:10",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "4887:3:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4887:17:10"
                      },
                      {
                        "arguments": [
                          {
                            "name": "tail",
                            "nodeType": "YulIdentifier",
                            "src": "4910:4:10"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "4916:9:10"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "4906:3:10"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "4906:20:10"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "4880:6:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4880:47:10"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "4880:47:10"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "4936:139:10",
                  "value": {
                    "arguments": [
                      {
                        "name": "tail",
                        "nodeType": "YulIdentifier",
                        "src": "5070:4:10"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_stringliteral_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe_to_t_string_memory_ptr_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "4944:124:10"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4944:131:10"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "4936:4:10"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "4814:9:10",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "4829:4:10",
                "type": ""
              }
            ],
            "src": "4663:419:10"
          }
        ]
      },
      "contents": "{\n\n    function cleanup_t_uint160(value) -> cleaned {\n        cleaned := and(value, 0xffffffffffffffffffffffffffffffffffffffff)\n    }\n\n    function cleanup_t_address(value) -> cleaned {\n        cleaned := cleanup_t_uint160(value)\n    }\n\n    function abi_encode_t_address_to_t_address_fromStack(value, pos) {\n        mstore(pos, cleanup_t_address(value))\n    }\n\n    function abi_encode_tuple_t_address__to_t_address__fromStack_reversed(headStart , value0) -> tail {\n        tail := add(headStart, 32)\n\n        abi_encode_t_address_to_t_address_fromStack(value0,  add(headStart, 0))\n\n    }\n\n    function cleanup_t_uint16(value) -> cleaned {\n        cleaned := and(value, 0xffff)\n    }\n\n    function abi_encode_t_uint16_to_t_uint16_fromStack(value, pos) {\n        mstore(pos, cleanup_t_uint16(value))\n    }\n\n    function abi_encode_tuple_t_uint16__to_t_uint16__fromStack_reversed(headStart , value0) -> tail {\n        tail := add(headStart, 32)\n\n        abi_encode_t_uint16_to_t_uint16_fromStack(value0,  add(headStart, 0))\n\n    }\n\n    function allocate_unbounded() -> memPtr {\n        memPtr := mload(64)\n    }\n\n    function revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() {\n        revert(0, 0)\n    }\n\n    function revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db() {\n        revert(0, 0)\n    }\n\n    function validator_revert_t_uint16(value) {\n        if iszero(eq(value, cleanup_t_uint16(value))) { revert(0, 0) }\n    }\n\n    function abi_decode_t_uint16(offset, end) -> value {\n        value := calldataload(offset)\n        validator_revert_t_uint16(value)\n    }\n\n    function abi_decode_tuple_t_uint16(headStart, dataEnd) -> value0 {\n        if slt(sub(dataEnd, headStart), 32) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\n\n        {\n\n            let offset := 0\n\n            value0 := abi_decode_t_uint16(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function validator_revert_t_address(value) {\n        if iszero(eq(value, cleanup_t_address(value))) { revert(0, 0) }\n    }\n\n    function abi_decode_t_address(offset, end) -> value {\n        value := calldataload(offset)\n        validator_revert_t_address(value)\n    }\n\n    function abi_decode_tuple_t_address(headStart, dataEnd) -> value0 {\n        if slt(sub(dataEnd, headStart), 32) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\n\n        {\n\n            let offset := 0\n\n            value0 := abi_decode_t_address(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_encode_tuple_t_uint16_t_uint16__to_t_uint16_t_uint16__fromStack_reversed(headStart , value1, value0) -> tail {\n        tail := add(headStart, 64)\n\n        abi_encode_t_uint16_to_t_uint16_fromStack(value0,  add(headStart, 0))\n\n        abi_encode_t_uint16_to_t_uint16_fromStack(value1,  add(headStart, 32))\n\n    }\n\n    function array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, length) -> updated_pos {\n        mstore(pos, length)\n        updated_pos := add(pos, 0x20)\n    }\n\n    function store_literal_in_memory_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe(memPtr) {\n\n        mstore(add(memPtr, 0), \"Ownable: new owner is the zero a\")\n\n        mstore(add(memPtr, 32), \"ddress\")\n\n    }\n\n    function abi_encode_t_stringliteral_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe_to_t_string_memory_ptr_fromStack(pos) -> end {\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 38)\n        store_literal_in_memory_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe(pos)\n        end := add(pos, 64)\n    }\n\n    function abi_encode_tuple_t_stringliteral_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\n        tail := add(headStart, 32)\n\n        mstore(add(headStart, 0), sub(tail, headStart))\n        tail := abi_encode_t_stringliteral_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe_to_t_string_memory_ptr_fromStack( tail)\n\n    }\n\n    function store_literal_in_memory_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe(memPtr) {\n\n        mstore(add(memPtr, 0), \"Ownable: caller is not the owner\")\n\n    }\n\n    function abi_encode_t_stringliteral_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe_to_t_string_memory_ptr_fromStack(pos) -> end {\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 32)\n        store_literal_in_memory_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe(pos)\n        end := add(pos, 32)\n    }\n\n    function abi_encode_tuple_t_stringliteral_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\n        tail := add(headStart, 32)\n\n        mstore(add(headStart, 0), sub(tail, headStart))\n        tail := abi_encode_t_stringliteral_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe_to_t_string_memory_ptr_fromStack( tail)\n\n    }\n\n}\n",
      "id": 10,
      "language": "Yul",
      "name": "#utility.yul"
    }
  ],
  "sourceMap": "119:611:7:-:0;;;;;;;;;;;;;936:32:0;955:12;:10;;;:12;;:::i;:::-;936:18;;;:32;;:::i;:::-;119:611:7;;640:96:3;693:7;719:10;712:17;;640:96;:::o;2433:187:0:-;2506:16;2525:6;;;;;;;;;;;2506:25;;2550:8;2541:6;;:17;;;;;;;;;;;;;;;;;;2604:8;2573:40;;2594:8;2573:40;;;;;;;;;;;;2496:124;2433:187;:::o;119:611:7:-;;;;;;;",
  "deployedSourceMap": "119:611:7:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;349:104;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;1831:101:0;;;:::i;:::-;;1201:85;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;157:30:7;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;243:100;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;494:234;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;2081:198:0;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;349:104:7;413:7;439;:5;:7::i;:::-;432:14;;349:104;:::o;1831:101:0:-;1094:13;:11;:13::i;:::-;1895:30:::1;1922:1;1895:18;:30::i;:::-;1831:101::o:0;1201:85::-;1247:7;1273:6;;;;;;;;;;;1266:13;;1201:85;:::o;157:30:7:-;;;;;;;;;;;;;:::o;243:100::-;295:6;320:16;;;;;;;;;;;313:23;;243:100;:::o;494:234::-;1094:13:0;:11;:13::i;:::-;582:16:7::1;;;;;;;;;;;572:26;;:6;:26;;::::0;568:39;600:7:::1;568:39;617:13;633:16:::0;::::1;;;;;;;;;;617:32;;678:6;659:16;;:25;;;;;;;;;;;;;;;;;;699:22;706:6;714;699:22;;;;;;;:::i;:::-;;;;;;;;558:170;1117:1:0;494:234:7::0;:::o;2081:198:0:-;1094:13;:11;:13::i;:::-;2189:1:::1;2169:22;;:8;:22;;::::0;2161:73:::1;;;;;;;;;;;;:::i;:::-;;;;;;;;;2244:28;2263:8;2244:18;:28::i;:::-;2081:198:::0;:::o;1359:130::-;1433:12;:10;:12::i;:::-;1422:23;;:7;:5;:7::i;:::-;:23;;;1414:68;;;;;;;;;;;;:::i;:::-;;;;;;;;;1359:130::o;2433:187::-;2506:16;2525:6;;;;;;;;;;;2506:25;;2550:8;2541:6;;:17;;;;;;;;;;;;;;;;;;2604:8;2573:40;;2594:8;2573:40;;;;;;;;;;;;2496:124;2433:187;:::o;640:96:3:-;693:7;719:10;712:17;;640:96;:::o;7:126:10:-;44:7;84:42;77:5;73:54;62:65;;7:126;;;:::o;139:96::-;176:7;205:24;223:5;205:24;:::i;:::-;194:35;;139:96;;;:::o;241:118::-;328:24;346:5;328:24;:::i;:::-;323:3;316:37;241:118;;:::o;365:222::-;458:4;496:2;485:9;481:18;473:26;;509:71;577:1;566:9;562:17;553:6;509:71;:::i;:::-;365:222;;;;:::o;593:89::-;629:7;669:6;662:5;658:18;647:29;;593:89;;;:::o;688:115::-;773:23;790:5;773:23;:::i;:::-;768:3;761:36;688:115;;:::o;809:218::-;900:4;938:2;927:9;923:18;915:26;;951:69;1017:1;1006:9;1002:17;993:6;951:69;:::i;:::-;809:218;;;;:::o;1114:117::-;1223:1;1220;1213:12;1360:120;1432:23;1449:5;1432:23;:::i;:::-;1425:5;1422:34;1412:62;;1470:1;1467;1460:12;1412:62;1360:120;:::o;1486:137::-;1531:5;1569:6;1556:20;1547:29;;1585:32;1611:5;1585:32;:::i;:::-;1486:137;;;;:::o;1629:327::-;1687:6;1736:2;1724:9;1715:7;1711:23;1707:32;1704:119;;;1742:79;;:::i;:::-;1704:119;1862:1;1887:52;1931:7;1922:6;1911:9;1907:22;1887:52;:::i;:::-;1877:62;;1833:116;1629:327;;;;:::o;1962:122::-;2035:24;2053:5;2035:24;:::i;:::-;2028:5;2025:35;2015:63;;2074:1;2071;2064:12;2015:63;1962:122;:::o;2090:139::-;2136:5;2174:6;2161:20;2152:29;;2190:33;2217:5;2190:33;:::i;:::-;2090:139;;;;:::o;2235:329::-;2294:6;2343:2;2331:9;2322:7;2318:23;2314:32;2311:119;;;2349:79;;:::i;:::-;2311:119;2469:1;2494:53;2539:7;2530:6;2519:9;2515:22;2494:53;:::i;:::-;2484:63;;2440:117;2235:329;;;;:::o;2570:324::-;2687:4;2725:2;2714:9;2710:18;2702:26;;2738:69;2804:1;2793:9;2789:17;2780:6;2738:69;:::i;:::-;2817:70;2883:2;2872:9;2868:18;2859:6;2817:70;:::i;:::-;2570:324;;;;;:::o;2900:169::-;2984:11;3018:6;3013:3;3006:19;3058:4;3053:3;3049:14;3034:29;;2900:169;;;;:::o;3075:225::-;3215:34;3211:1;3203:6;3199:14;3192:58;3284:8;3279:2;3271:6;3267:15;3260:33;3075:225;:::o;3306:366::-;3448:3;3469:67;3533:2;3528:3;3469:67;:::i;:::-;3462:74;;3545:93;3634:3;3545:93;:::i;:::-;3663:2;3658:3;3654:12;3647:19;;3306:366;;;:::o;3678:419::-;3844:4;3882:2;3871:9;3867:18;3859:26;;3931:9;3925:4;3921:20;3917:1;3906:9;3902:17;3895:47;3959:131;4085:4;3959:131;:::i;:::-;3951:139;;3678:419;;;:::o;4103:182::-;4243:34;4239:1;4231:6;4227:14;4220:58;4103:182;:::o;4291:366::-;4433:3;4454:67;4518:2;4513:3;4454:67;:::i;:::-;4447:74;;4530:93;4619:3;4530:93;:::i;:::-;4648:2;4643:3;4639:12;4632:19;;4291:366;;;:::o;4663:419::-;4829:4;4867:2;4856:9;4852:18;4844:26;;4916:9;4910:4;4906:20;4902:1;4891:9;4887:17;4880:47;4944:131;5070:4;4944:131;:::i;:::-;4936:139;;4663:419;;;:::o",
  "source": "pragma solidity >=0.8.0 <0.9.0;\n// SPDX-License-Identifier: MIT\n\nimport \"@openzeppelin/contracts/access/Ownable.sol\";\n\ncontract dreamBidFee is Ownable {\n    uint16 public _dreamBiddingFee;\n\n    event FeeSet(uint16 newFee, uint16 oldFee);\n\n    function protocolFee() public view virtual returns (uint16) {\n        return _dreamBiddingFee;\n    }\n\n    function getProtocolOwnerAddress() public view virtual returns (address) {\n        return owner();\n    }\n\n    // Set Protocol Fee in percent\n    function setProtocolFee(uint16 newFee) public virtual onlyOwner {\n        if (newFee == _dreamBiddingFee) return;\n\n        uint16 oldFee = _dreamBiddingFee;\n        _dreamBiddingFee = newFee;\n        emit FeeSet(newFee, oldFee);\n    }\n}\n",
  "sourcePath": "/media/dell/17f09f70-0626-4927-a787-2813ab7ed2c0/dell/Dream Bid/Dream-Bid/contracts/dreamBidFee.sol",
  "ast": {
    "absolutePath": "project:/contracts/dreamBidFee.sol",
    "exportedSymbols": {
      "Context": [
        266
      ],
      "Ownable": [
        112
      ],
      "dreamBidFee": [
        824
      ]
    },
    "id": 825,
    "license": "MIT",
    "nodeType": "SourceUnit",
    "nodes": [
      {
        "id": 769,
        "literals": [
          "solidity",
          ">=",
          "0.8",
          ".0",
          "<",
          "0.9",
          ".0"
        ],
        "nodeType": "PragmaDirective",
        "src": "0:31:7"
      },
      {
        "absolutePath": "@openzeppelin/contracts/access/Ownable.sol",
        "file": "@openzeppelin/contracts/access/Ownable.sol",
        "id": 770,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 825,
        "sourceUnit": 113,
        "src": "65:52:7",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "abstract": false,
        "baseContracts": [
          {
            "baseName": {
              "id": 771,
              "name": "Ownable",
              "nameLocations": [
                "143:7:7"
              ],
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 112,
              "src": "143:7:7"
            },
            "id": 772,
            "nodeType": "InheritanceSpecifier",
            "src": "143:7:7"
          }
        ],
        "canonicalName": "dreamBidFee",
        "contractDependencies": [],
        "contractKind": "contract",
        "fullyImplemented": true,
        "id": 824,
        "linearizedBaseContracts": [
          824,
          112,
          266
        ],
        "name": "dreamBidFee",
        "nameLocation": "128:11:7",
        "nodeType": "ContractDefinition",
        "nodes": [
          {
            "constant": false,
            "functionSelector": "9c37cd7b",
            "id": 774,
            "mutability": "mutable",
            "name": "_dreamBiddingFee",
            "nameLocation": "171:16:7",
            "nodeType": "VariableDeclaration",
            "scope": 824,
            "src": "157:30:7",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint16",
              "typeString": "uint16"
            },
            "typeName": {
              "id": 773,
              "name": "uint16",
              "nodeType": "ElementaryTypeName",
              "src": "157:6:7",
              "typeDescriptions": {
                "typeIdentifier": "t_uint16",
                "typeString": "uint16"
              }
            },
            "visibility": "public"
          },
          {
            "anonymous": false,
            "eventSelector": "5eceb83a41b09b5e263d7630d38aa237669c42bf1a589221313ea56e6d799e88",
            "id": 780,
            "name": "FeeSet",
            "nameLocation": "200:6:7",
            "nodeType": "EventDefinition",
            "parameters": {
              "id": 779,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 776,
                  "indexed": false,
                  "mutability": "mutable",
                  "name": "newFee",
                  "nameLocation": "214:6:7",
                  "nodeType": "VariableDeclaration",
                  "scope": 780,
                  "src": "207:13:7",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint16",
                    "typeString": "uint16"
                  },
                  "typeName": {
                    "id": 775,
                    "name": "uint16",
                    "nodeType": "ElementaryTypeName",
                    "src": "207:6:7",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint16",
                      "typeString": "uint16"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 778,
                  "indexed": false,
                  "mutability": "mutable",
                  "name": "oldFee",
                  "nameLocation": "229:6:7",
                  "nodeType": "VariableDeclaration",
                  "scope": 780,
                  "src": "222:13:7",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint16",
                    "typeString": "uint16"
                  },
                  "typeName": {
                    "id": 777,
                    "name": "uint16",
                    "nodeType": "ElementaryTypeName",
                    "src": "222:6:7",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint16",
                      "typeString": "uint16"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "206:30:7"
            },
            "src": "194:43:7"
          },
          {
            "body": {
              "id": 787,
              "nodeType": "Block",
              "src": "303:40:7",
              "statements": [
                {
                  "expression": {
                    "id": 785,
                    "name": "_dreamBiddingFee",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 774,
                    "src": "320:16:7",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint16",
                      "typeString": "uint16"
                    }
                  },
                  "functionReturnParameters": 784,
                  "id": 786,
                  "nodeType": "Return",
                  "src": "313:23:7"
                }
              ]
            },
            "functionSelector": "b0e21e8a",
            "id": 788,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "protocolFee",
            "nameLocation": "252:11:7",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 781,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "263:2:7"
            },
            "returnParameters": {
              "id": 784,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 783,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 788,
                  "src": "295:6:7",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint16",
                    "typeString": "uint16"
                  },
                  "typeName": {
                    "id": 782,
                    "name": "uint16",
                    "nodeType": "ElementaryTypeName",
                    "src": "295:6:7",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint16",
                      "typeString": "uint16"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "294:8:7"
            },
            "scope": 824,
            "src": "243:100:7",
            "stateMutability": "view",
            "virtual": true,
            "visibility": "public"
          },
          {
            "body": {
              "id": 796,
              "nodeType": "Block",
              "src": "422:31:7",
              "statements": [
                {
                  "expression": {
                    "arguments": [],
                    "expression": {
                      "argumentTypes": [],
                      "id": 793,
                      "name": "owner",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 40,
                      "src": "439:5:7",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_internal_view$__$returns$_t_address_$",
                        "typeString": "function () view returns (address)"
                      }
                    },
                    "id": 794,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "nameLocations": [],
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "439:7:7",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "functionReturnParameters": 792,
                  "id": 795,
                  "nodeType": "Return",
                  "src": "432:14:7"
                }
              ]
            },
            "functionSelector": "3c453a67",
            "id": 797,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "getProtocolOwnerAddress",
            "nameLocation": "358:23:7",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 789,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "381:2:7"
            },
            "returnParameters": {
              "id": 792,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 791,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 797,
                  "src": "413:7:7",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 790,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "413:7:7",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "412:9:7"
            },
            "scope": 824,
            "src": "349:104:7",
            "stateMutability": "view",
            "virtual": true,
            "visibility": "public"
          },
          {
            "body": {
              "id": 822,
              "nodeType": "Block",
              "src": "558:170:7",
              "statements": [
                {
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint16",
                      "typeString": "uint16"
                    },
                    "id": 806,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 804,
                      "name": "newFee",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 799,
                      "src": "572:6:7",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint16",
                        "typeString": "uint16"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "==",
                    "rightExpression": {
                      "id": 805,
                      "name": "_dreamBiddingFee",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 774,
                      "src": "582:16:7",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint16",
                        "typeString": "uint16"
                      }
                    },
                    "src": "572:26:7",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 808,
                  "nodeType": "IfStatement",
                  "src": "568:39:7",
                  "trueBody": {
                    "functionReturnParameters": 803,
                    "id": 807,
                    "nodeType": "Return",
                    "src": "600:7:7"
                  }
                },
                {
                  "assignments": [
                    810
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 810,
                      "mutability": "mutable",
                      "name": "oldFee",
                      "nameLocation": "624:6:7",
                      "nodeType": "VariableDeclaration",
                      "scope": 822,
                      "src": "617:13:7",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint16",
                        "typeString": "uint16"
                      },
                      "typeName": {
                        "id": 809,
                        "name": "uint16",
                        "nodeType": "ElementaryTypeName",
                        "src": "617:6:7",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint16",
                          "typeString": "uint16"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 812,
                  "initialValue": {
                    "id": 811,
                    "name": "_dreamBiddingFee",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 774,
                    "src": "633:16:7",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint16",
                      "typeString": "uint16"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "617:32:7"
                },
                {
                  "expression": {
                    "id": 815,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "id": 813,
                      "name": "_dreamBiddingFee",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 774,
                      "src": "659:16:7",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint16",
                        "typeString": "uint16"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "id": 814,
                      "name": "newFee",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 799,
                      "src": "678:6:7",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint16",
                        "typeString": "uint16"
                      }
                    },
                    "src": "659:25:7",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint16",
                      "typeString": "uint16"
                    }
                  },
                  "id": 816,
                  "nodeType": "ExpressionStatement",
                  "src": "659:25:7"
                },
                {
                  "eventCall": {
                    "arguments": [
                      {
                        "id": 818,
                        "name": "newFee",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 799,
                        "src": "706:6:7",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint16",
                          "typeString": "uint16"
                        }
                      },
                      {
                        "id": 819,
                        "name": "oldFee",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 810,
                        "src": "714:6:7",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint16",
                          "typeString": "uint16"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_uint16",
                          "typeString": "uint16"
                        },
                        {
                          "typeIdentifier": "t_uint16",
                          "typeString": "uint16"
                        }
                      ],
                      "id": 817,
                      "name": "FeeSet",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 780,
                      "src": "699:6:7",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_event_nonpayable$_t_uint16_$_t_uint16_$returns$__$",
                        "typeString": "function (uint16,uint16)"
                      }
                    },
                    "id": 820,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "nameLocations": [],
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "699:22:7",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 821,
                  "nodeType": "EmitStatement",
                  "src": "694:27:7"
                }
              ]
            },
            "functionSelector": "e4467f35",
            "id": 823,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 802,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 801,
                  "name": "onlyOwner",
                  "nameLocations": [
                    "548:9:7"
                  ],
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 31,
                  "src": "548:9:7"
                },
                "nodeType": "ModifierInvocation",
                "src": "548:9:7"
              }
            ],
            "name": "setProtocolFee",
            "nameLocation": "503:14:7",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 800,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 799,
                  "mutability": "mutable",
                  "name": "newFee",
                  "nameLocation": "525:6:7",
                  "nodeType": "VariableDeclaration",
                  "scope": 823,
                  "src": "518:13:7",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint16",
                    "typeString": "uint16"
                  },
                  "typeName": {
                    "id": 798,
                    "name": "uint16",
                    "nodeType": "ElementaryTypeName",
                    "src": "518:6:7",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint16",
                      "typeString": "uint16"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "517:15:7"
            },
            "returnParameters": {
              "id": 803,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "558:0:7"
            },
            "scope": 824,
            "src": "494:234:7",
            "stateMutability": "nonpayable",
            "virtual": true,
            "visibility": "public"
          }
        ],
        "scope": 825,
        "src": "119:611:7",
        "usedErrors": []
      }
    ],
    "src": "0:731:7"
  },
  "compiler": {
    "name": "solc",
    "version": "0.8.17+commit.8df45f5f.Emscripten.clang"
  },
  "networks": {
    "97": {
      "events": {},
      "links": {},
      "address": "0x7849cB5A5623670c328018d8778a75Da11F47084",
      "transactionHash": "0xbed1a7d321cc959b3eeec11ea7dcf00592f6a01852553d21de54870a9800af0b"
    },
    "5777": {
      "events": {
        "0x5eceb83a41b09b5e263d7630d38aa237669c42bf1a589221313ea56e6d799e88": {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint16",
              "name": "newFee",
              "type": "uint16"
            },
            {
              "indexed": false,
              "internalType": "uint16",
              "name": "oldFee",
              "type": "uint16"
            }
          ],
          "name": "FeeSet",
          "type": "event"
        },
        "0x8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0": {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "previousOwner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "name": "OwnershipTransferred",
          "type": "event"
        }
      },
      "links": {},
      "address": "0x43B86651E9422616c5282283ed89358E7AF5235d",
      "transactionHash": "0x42d59a3f700fb2fa78b7325990f6cb1f822aa7999e6a84a7e28bd1ce089ac95d"
    }
  },
  "schemaVersion": "3.4.10",
  "updatedAt": "2023-05-04T04:58:40.669Z",
  "networkType": "ethereum",
  "devdoc": {
    "kind": "dev",
    "methods": {
      "owner()": {
        "details": "Returns the address of the current owner."
      },
      "renounceOwnership()": {
        "details": "Leaves the contract without owner. It will not be possible to call `onlyOwner` functions anymore. Can only be called by the current owner. NOTE: Renouncing ownership will leave the contract without an owner, thereby removing any functionality that is only available to the owner."
      },
      "transferOwnership(address)": {
        "details": "Transfers ownership of the contract to a new account (`newOwner`). Can only be called by the current owner."
      }
    },
    "version": 1
  },
  "userdoc": {
    "kind": "user",
    "methods": {},
    "version": 1
  }
}